/**
 * Combine plusieurs fonctions de comparaison
 */
function combineMultipleSort<T>(
  ...comparators: Array<(a: T, b: T) => number>
): (a: T, b: T) => number {
  return (a, b) => {
    for (const cmp of comparators) {
      const result = cmp(a, b);
      if (result !== 0) return result;
    }
    return 0;
  };
}

export const sortUtil = {
  combineMultipleSort,
};
